import {EntityData, field, SearchModel, SearchResult} from "@fedelta-pos/data-client";
import {Injectable, Injector} from "@angular/core";

export enum BeaconOrderType {
    TABLE_ONLY = <any>"TABLE_ONLY",
    PICKUP_ONLY = <any>"PICKUP_ONLY",
    TABLE_OR_PICKUP_ONLY = <any>"TABLE_OR_PICKUP_ONLY"
}

export class BeaconData extends EntityData<BeaconData> {
    @field id: string;
    @field appStore: number;
    @field appStoreGroup: string;
    @field orderType: BeaconOrderType;
    @field tableNumber: string;
    @field dealCode: string;
}

/**
 * Search model to look up a beacon
 */
@Injectable()
export class BeaconSearchModel extends SearchModel<BeaconData> {
    constructor(injector: Injector) {
        console.log("--- BeaconSearchModel");
        super(injector, BeaconData);
    }

    async lookupBeacon(id: string): Promise<BeaconData> {
        const searchResult: SearchResult = await super.searchRecords({"id": id}, undefined, undefined, undefined).toPromise();
        return searchResult.totalCount ? searchResult.data[0] : null;
    }
}



// WEBPACK FOOTER //
// ./src/app/beacon/beacon-search.model.ts